import {
  CButton,
  CCol,
  CContainer,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from "@coreui/react";
import { useState } from "react";
import { Spinner } from "react-bootstrap";
import { deleteItem } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { errorAlert } from "../utils/messages";
import Establishment from "../../models/establishment";

interface EstablishmentDeleteModalProps {
  show: boolean;
  establishment?: Establishment;
  onCancel: () => void | Promise<void>;
  onSuccess: () => void | Promise<void>;
}

const EstablishmentDeleteModal: React.FC<EstablishmentDeleteModalProps> = ({
  show,
  establishment,
  onCancel,
  onSuccess,
}) => {
  const [submitting, setSubmitting] = useState(false);

  const message = establishment
    ? `Está seguro de que quiere eliminar el Establecimiento  ${establishment.denomination} ${establishment.code}`
    : "";

  const onDeleteClick = async () => {
    if (establishment !== undefined) {
      setSubmitting(true);
      const establishmentStatus = await deleteItem(
        `/establishments/${establishment.id}/`,
        establishment
      );

      if (establishmentStatus.status !== SUCCESS) {
        let message = "Ha ocurrido un error!!";
        if (establishmentStatus.detail !== undefined) {
          message = establishmentStatus.detail;
        }
        errorAlert(message);
      } else {
        onSuccess();
      }

      setSubmitting(false);
    }
  };

  return (
    <CModal show={show} className="modal-danger" onClosed={onCancel} size="xl">
      <CModalHeader closeButton>
        <CModalTitle>Eliminar</CModalTitle>
      </CModalHeader>
      <CModalBody>
        <CContainer fluid>
          <CRow>
            <CCol sm="12">
              <h2>{message}</h2>
            </CCol>
          </CRow>
        </CContainer>
      </CModalBody>
      <CModalFooter>
        <CButton disabled={submitting} onClick={onDeleteClick} color="danger">
          {submitting ? (
            <Spinner
              animation="grow"
              style={{
                height: "17px",
                width: "17px",
                marginTop: "auto",
                marginBottom: "auto",
                marginRight: "10px",
              }}
            />
          ) : (
            <></>
          )}
          {submitting ? "Eliminando..." : "Eliminar"}
        </CButton>
      </CModalFooter>
    </CModal>
  );
};

export default EstablishmentDeleteModal;
